export enum MagicColor {
	W = "W",
	U = "U",
	B = "B",
	R = "R",
	G = "G",
	C = "C",
}

export const magicColors = Object.values(MagicColor);

export const magicColorNames = {
	[MagicColor.W]: "white",
	[MagicColor.U]: "blue",
	[MagicColor.B]: "black",
	[MagicColor.R]: "red",
	[MagicColor.G]: "green",
	[MagicColor.C]: "colorless",
};

export const basicLandNames = {
	[MagicColor.W]: "Plains",
	[MagicColor.U]: "Island",
	[MagicColor.B]: "Swamp",
	[MagicColor.R]: "Mountain",
	[MagicColor.G]: "Forest",
	[MagicColor.C]: "Wastes",
};
